import mHelper from '../../config/Helper';
import reqwest from 'reqwest';
var isLogin = JSON.parse(mHelper.GET_COOKIES('login_portal'));

class PaidControllers {

    GET_SELECT_INVOICE = (id,callback) => {
        fetch(mHelper.URL_API() + "/data-fpjp/" + id, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                "Authorization": "Bearer " + isLogin.token
            },
        })
        .then((response) => response.json())
        .then((responseJson) => {
            callback(responseJson);
        })
        .catch((error) => {
            console.error(error);
        });
    }


    
    SUBMIT_INVOICE = (id,callback) => {
        fetch(mHelper.URL_API() + "/paid-invoice/submit_paid", {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                "Authorization": "Bearer " + isLogin.token
            },
            body:JSON.stringify({
                id:id
            })
        })
        .then((response) => response.json())
        .then((responseJson) => {
            callback(responseJson);
        })
        .catch((error) => {
            console.error(error);
        });
    }


    DELETE_INVOICE = (id,callback) => {
        fetch(mHelper.URL_API() + "/paid-invoice/delete_paid", {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                "Authorization": "Bearer " + isLogin.token
            },
            body:JSON.stringify({
                id:id
            })
        })
        .then((response) => response.json())
        .then((responseJson) => {
            callback(responseJson);
        })
        .catch((error) => {
            console.error(error);
        });
    }


    UPDATE_INVOICE_DATA = (id,row,callback) => {
        fetch(mHelper.URL_API() + "/paid-invoice/update/"+id, {
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                "Authorization": "Bearer " + isLogin.token
            },
            body:JSON.stringify(row)
        })
        .then((response) => response.json())
        .then((responseJson) => {
            callback(responseJson);
        })
        .catch((error) => {
            console.error(error);
        });
    }

    DELETE_FILE_INVOICE = (id,types,name,callback) => {
        fetch(mHelper.URL_API() + "/paid-invoice/delete-file", {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                "Authorization": "Bearer " + isLogin.token
            },
            body:JSON.stringify({
                id: id,
                types:types,
                name: name
            })
        })
        .then((response) => response.json())
        .then((responseJson) => {
            callback(responseJson);
        })
        .catch((error) => {
            console.error(error);
        });
    }

    ADD_INVOICE_DRAFT = (periode,ad_code,ad_name,type_trx,at_create,by_create,callback) => {
        fetch(mHelper.URL_API() + "/paid-invoice/create-draft", {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                "Authorization": "Bearer " + isLogin.token
            },
            body:JSON.stringify({
                periode: periode,
                ad_code:ad_code,
                ad_name: ad_name,
                type_trx: type_trx,
                at_create: at_create,
                by_create: by_create
            })
        })
        .then((response) => response.json())
        .then((responseJson) => {
            callback(responseJson);
        })
        .catch((error) => {
            console.error(error);
        });
    }

    UPLOAD_INVOICE = (fileInvoice,callback) =>{
        const formData = new FormData();
        fileInvoice.forEach(file => {
            formData.append('doc_invoice', file);
        });
        reqwest({
            url: mHelper.URL_API() + "paid-invoice",
            method: 'post',
            headers: {
                "Authorization": "Bearer " + isLogin.token
            },
            processData: false,
            data: formData,
            success: (r) => {
                callback({success:true, data : r, message:"success"});
            },
            error: () => {
                callback({success:false, data:[], message : "add paid invoice  error"});
            },
        });
    }


    ADD_INVOICE = (fileInvoice ,fileFakturPajak,fileBARRecon,fileSummary, Periode,row,callback) => {
        const formData = new FormData();
        fileInvoice.forEach(file => {
            formData.append('doc_invoice', file);
        });

        fileFakturPajak.forEach(file => {
            formData.append('doc_fp', file);
        });

        fileBARRecon.forEach(file => {
            formData.append('bar_recon', file);
        });

        fileSummary.forEach(file => {
            formData.append('doc_summary', file);
        });

        //Pelengkap
        formData.append("periode",  Periode);
        formData.append("transaction_code", "");
        formData.append("type_trx", 1);
        formData.append("at_create", mHelper.CURRENT_TIME_MILIS());
        formData.append("by_create", isLogin.id);
        formData.append("state", 1);

        var skipKey = ["bar_attachment","fp_attachment","inv_attachment","summary_attachment","periode"];
        for(var i in row){
            if(skipKey.indexOf(i) != -1){
                continue;
            }
            formData.append(i,  row[i]);
        }
        reqwest({
            url: mHelper.URL_API() + "paid-invoice",
            method: 'post',
            headers: {
                "Authorization": "Bearer " + isLogin.token
            },
            processData: false,
            data: formData,
            success: (r) => {
                callback({success:true, data : r, message:"success"});
            },
            error: () => {
                callback({success:false, data:[], message : "add paid invoice  error"});
            },
        });
    }

    GET_DATA_INVOICE = (filter, callback) => {
        var infoFilter = JSON.stringify(filter);
        fetch(mHelper.URL_API() + "paid-invoice?filter=" + infoFilter, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                "Authorization": "Bearer " + isLogin.token
            },
        })
        .then((response) => response.json())
        .then((responseJson) => {
            callback(responseJson);
        })
        .catch((error) => {
            console.error(error);
        });
    }

    GET_FILE_DOC = (params, callback) => {
        fetch(mHelper.URL_API() + "files/invoice", {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                "Authorization": "Bearer " + isLogin.token
            },
            body:JSON.stringify(params)
        })
        .then((response) => response.json())
        .then((responseJson) => {
            callback(responseJson);
        })
        .catch((error) => {
            console.error(error);
        });
    }

    GET_DATA_DIGIPOS = (filter, callback) => {
        fetch(mHelper.URL_API() + "/paid-data-digipos?filter="+JSON.stringify(filter), {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                "Authorization": "Bearer " + isLogin.token
            },
        })
        .then((response) => response.json())
        .then((responseJson) => {
            callback(responseJson);
        })
        .catch((error) => {
            console.error(error);
        });
    }

}

const mPaidControllers = new PaidControllers();
export default mPaidControllers;